import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";

interface DetailCardProps {
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
  showLine?: boolean;
}

const DetailCard: React.FC<DetailCardProps> = ({ title="", subtitle="", children, showLine=false }) => {
  return (
    <Card className='mb-2'>
      <CardHeader>
        <CardTitle className="text-lg">{title}</CardTitle>
        {showLine && <hr className="h-px bg-gray-200 border-0 dark:bg-gray-200"></hr>}
        <CardDescription className="text-sm">{subtitle}</CardDescription>
      </CardHeader>
      {children && (
        <CardContent>
          {children}
        </CardContent>
      )}
    </Card>
  );
};

export default DetailCard;